import FormattedMessage from 'I18n/components/FormattedMessage';
import ModuleDetailsResponse from 'marketplace-ui-assets-core/details/records/ModuleDetailsResponse';
import MetaRobots from 'marketplace-ui-common/components/elements/MetaRobots';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'marketplace-ui-common/components/prerender/PrerenderStatusCode';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import HSPageViewTracker from 'marketplace-ui-common/tracking/components/HSPageViewTracker';
import { DetailsError } from 'marketplace-ui-details/error/DetailsError';
import { useUnifiedDetails } from 'marketplace-ui-details/hooks/useUnifiedDetails';
import { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { useLocation, useParams } from 'react-router-dom';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { useRouteOfferingType } from '../../common/hooks/useRouteOfferingType';
import StorefrontUsageTrackerProvider from '../../context/StorefrontUsageTrackerProvider';
import { PublicOnly, getAppContextCoreType } from '../../selectors/app';
import { getRootUrl, getStorefrontRoute } from '../../utils/urls';
import ModuleDetailsPage from '../components/ModuleDetailsPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModuleDetailsError = ({
  children
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(PublicOnly, {
    children: /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx(MetaRobots, {
        directive: ['nofollow', 'noindex']
      }), /*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(PrerenderStatusCode, {
        statusCode: 404
      })]
    })
  }), children]
});
export default function ModuleDetailsContainer() {
  const appContext = useSelector(getAppContextCoreType);
  const offeringType = useRouteOfferingType();
  const {
    pathname
  } = useLocation();
  const {
    slug
  } = useParams();
  const unifiedDetailsResponse = useUnifiedDetails({
    appContext,
    slug
  });
  const {
    unifiedDetailsData,
    unifiedDetailsLoading,
    unifiedDetailsError
  } = unifiedDetailsResponse;
  const moduleDetails = useMemo(() => {
    return new ModuleDetailsResponse(unifiedDetailsData);
  }, [unifiedDetailsData]);
  const requestState = getDataFetchingClientRequestState(unifiedDetailsError, unifiedDetailsLoading);
  if (unifiedDetailsError) {
    return /*#__PURE__*/_jsx(ModuleDetailsError, {
      children: /*#__PURE__*/_jsx(NavMarker, {
        name: "MODULE_DETAILS_ERROR_LOAD",
        children: /*#__PURE__*/_jsx(DetailsError, {
          unifiedDetailsError: unifiedDetailsError,
          renderedErrorLink: /*#__PURE__*/_jsx(UIRouterNavButton, {
            exact: true,
            to: getStorefrontRoute(offeringType),
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.error.notFound.button"
            })
          })
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [requestState === 'SUCCEEDED' ? /*#__PURE__*/_jsx(ModuleDetailsPage, {
      moduleDetails: moduleDetails
    }, `module-details-${slug}`) : null, /*#__PURE__*/_jsx(HSPageViewTracker, {
      pathname: `${getRootUrl()}${pathname}`
    })]
  });
}